/**
 * Removes `lang` from the query string so URLs stay clean. Language is stored in localStorage.
 * Still honors `?lang=` on first load (LanguageContext reads it before this runs).
 */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LanguageUrlSync() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (!params.has('lang')) return;
    params.delete('lang');
    const next = params.toString();
    navigate({ pathname, search: next ? `?${next}` : '' }, { replace: true });
  }, [pathname, search, navigate]);

  return null;
}
